/* logo-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbvbI6%7Bdisplay%3Ainline-block%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._26BoRwdnbC%7Bline-height%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0C0F9q1qiM%7B--tile-color%3A%23dddee1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzRvDB%7Bcolor%3A%23101214%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzZU00%7Bcolor%3A%23e2e3e4%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0Vey7F%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VSPN1%7Bheight%3A20px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VoWWg%7Bheight%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VUofl%7Bheight%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VUF4f%7Bheight%3A40px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VpJKa%7Bheight%3A3pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._07PX8Iy7kJ%7B--text-color%3Avar(--ds-text%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._07PX8InrF4%7B--text-color%3A%23a9abaf%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._07PX8ICl79%7B--text-color%3A%231e1f21%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._07PX8It28M%7B--text-color%3A%23fff%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._07PX8IBRVV%7B--text-color%3A%23505258%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._36J4jy2bHZ%7B--icon-color%3A%231868db%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0C0F9qRvDB%7B--tile-color%3A%23101214%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0g0wFMMlgR%7B--border-color%3A%234b4d51%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._36J4jynrF4%7B--icon-color%3A%23a9abaf%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0C0F9qMlgR%7B--tile-color%3A%234b4d51%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0g0wFMnrF4%7B--border-color%3A%23a9abaf%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._36J4jyMmzW%7B--icon-color%3A%231f1f21%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0C0F9qt28M%7B--tile-color%3A%23fff%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0g0wFMMmzW%7B--border-color%3A%231f1f21%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0g0wFM1qiM%7B--border-color%3A%23dddee1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._36J4jyBRVV%7B--icon-color%3A%23505258%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0g0wFMBRVV%7B--border-color%3A%23505258%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._36J4jyt28M%7B--icon-color%3A%23fff%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0g0wFMt28M%7B--border-color%3A%23fff%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2PY8Z66PYH%7B--rovo-blue-color%3A%23357de8%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._05MzPYmPNR%7B--rovo-yellow-color%3A%23fca700%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Yajk0kYsX%7B--rovo-purple-color%3A%23bf63f3%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._40KAGSJ5Ia%7B--rovo-green-color%3A%2382b536%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2PY8Z6nrF4%7B--rovo-blue-color%3A%23a9abaf%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._05MzPYnrF4%7B--rovo-yellow-color%3A%23a9abaf%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Yajk0nrF4%7B--rovo-purple-color%3A%23a9abaf%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._40KAGSnrF4%7B--rovo-green-color%3A%23a9abaf%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2PY8Z6RvDB%7B--rovo-blue-color%3A%23101214%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._05MzPYRvDB%7B--rovo-yellow-color%3A%23101214%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Yajk0RvDB%7B--rovo-purple-color%3A%23101214%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._40KAGSRvDB%7B--rovo-green-color%3A%23101214%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2PY8Z62bHZ%7B--rovo-blue-color%3A%231868db%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._05MzPY2bHZ%7B--rovo-yellow-color%3A%231868db%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Yajk02bHZ%7B--rovo-purple-color%3A%231868db%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._40KAGS2bHZ%7B--rovo-green-color%3A%231868db%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2PY8Z6yL8i%7B--rovo-blue-color%3Ainitial%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._05MzPYyL8i%7B--rovo-yellow-color%3Ainitial%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Yajk0yL8i%7B--rovo-purple-color%3Ainitial%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._40KAGSyL8i%7B--rovo-green-color%3Ainitial%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2PY8Z6BRVV%7B--rovo-blue-color%3A%23505258%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._05MzPYBRVV%7B--rovo-yellow-color%3A%23505258%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Yajk0BRVV%7B--rovo-purple-color%3A%23505258%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._40KAGSBRVV%7B--rovo-green-color%3A%23505258%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2PY8Z6t28M%7B--rovo-blue-color%3A%23fff%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._05MzPYt28M%7B--rovo-yellow-color%3A%23fff%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Yajk0t28M%7B--rovo-purple-color%3A%23fff%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._40KAGSt28M%7B--rovo-green-color%3A%23fff%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._36J4jyyL8i%7B--icon-color%3Ainitial%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0C0F9qyL8i%7B--tile-color%3Ainitial%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0C0F9qCl79%7B--tile-color%3A%231e1f21%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0C0F9q2bHZ%7B--tile-color%3A%231868db%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._36J4jyCl79%7B--icon-color%3A%231e1f21%7D");
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';
import { type LogoSize } from './types';
const styles = {
  root: "_3iDTPbvbI6 _26BoRwdnbC",
  TEMP_assets: "_0C0F9q1qiM"
};

// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const logoTextColorMap = {
  light: "_1UtDYzRvDB",
  dark: "_1UtDYzZU00"
};
const sizeMap = {
  xxsmall: "_0jFU0Vey7F",
  xsmall: "_0jFU0VSPN1",
  small: "_0jFU0VoWWg",
  medium: "_0jFU0VUofl",
  large: "_0jFU0VUF4f",
  xlarge: "_0jFU0VpJKa"
};

/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
const textLightAppearanceMap = {
  brand: "_07PX8Iy7kJ",
  neutral: "_07PX8IBRVV",
  inverse: "_07PX8It28M",
  legacy: "_07PX8It28M"
};

/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
const textDarkAppearanceMap = {
  brand: "_07PX8Iy7kJ",
  neutral: "_07PX8InrF4",
  inverse: "_07PX8ICl79",
  legacy: "_07PX8It28M"
};

/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
const cloudLightAppearanceMap = {
  brand: "_36J4jyyL8i _0C0F9qyL8i",
  neutral: "_36J4jyBRVV _0C0F9q1qiM",
  inverse: "_36J4jyCl79 _0C0F9qt28M",
  legacy: "_36J4jyt28M _0C0F9q2bHZ"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
const cloudDarkAppearanceMap = {
  brand: "_36J4jyyL8i _0C0F9qyL8i",
  neutral: "_36J4jynrF4 _0C0F9qMlgR",
  inverse: "_36J4jyt28M _0C0F9qCl79",
  legacy: "_36J4jyt28M _0C0F9q2bHZ"
};

/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
const dataCenterLightAppearanceMap = {
  brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
  neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
  inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
  legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
};

/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
const dataCenterDarkAppearanceMap = {
  brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
  neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
  inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
  legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const rovoDarkAppearanceMap = {
  brand: "_2PY8Z66PYH _05MzPYmPNR _0Yajk0kYsX _40KAGSJ5Ia",
  neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
  inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
  legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const rovoLightAppearanceMap = {
  brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
  neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
  inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
  legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};

/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */

type LogoWrapperProps = {
  appearance: 'brand' | 'neutral' | 'inverse' | 'legacy';
  customThemeSvg?: string;
  iconColor?: string;
  isAssets?: boolean;
  label: string;
  size?: LogoSize;
  svg: string;
  testId?: string;
  textColor?: string;
  type?: 'tile' | 'rovo' | 'data-center';
};
export function LogoWrapper({
  appearance = 'brand',
  size = 'small',
  svg,
  customThemeSvg,
  label,
  testId: userDefinedTestId,
  iconColor: customIconColor,
  textColor: customTextColor,
  isAssets = false,
  type = 'tile'
}: LogoWrapperProps): JSX.Element {
  const {
    colorMode
  } = useThemeObserver();
  const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
  const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
  return <span style={({
    // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    '--themed-text-color': customTextColor || 'inherit'
  } as React.CSSProperties)} data-testid={testId}
  // If the label is provided an empty string, we want to remove the element from the accessibility tree.
  aria-label={label ? label : undefined} role={label ? 'img' : undefined} aria-hidden={label === '' ? true : undefined}
  // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
  // This is because the SVG elements are static and will not change, so we get a little performance benefit by
  // bypassing React.
  dangerouslySetInnerHTML={{
    __html: isCustomThemed ? customThemeSvg : svg
  }} className={ax([styles.root,
  // Setting the color so that the SVG can inherit the correct text color using "currentColor"
  logoTextColorMap[colorMode ?? 'light'], sizeMap[size], colorMode === 'dark' ? textDarkAppearanceMap[appearance] : textLightAppearanceMap[appearance], colorMode === 'dark' ? dataCenterDarkAppearanceMap[appearance] : dataCenterLightAppearanceMap[appearance], type === 'rovo' ? colorMode === 'dark' ? rovoDarkAppearanceMap[appearance] : rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? cloudDarkAppearanceMap[appearance] : cloudLightAppearanceMap[appearance], isAssets && appearance === 'brand' && (fg('assets-platform-branding') || fg('assets-platform-branding-v2')) && styles.TEMP_assets])} />;
}